import { useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';

export const useThemeContext = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useThemeContext must be used inside ThemeProvider');
  }
  return ctx;
};
